import React from 'react';
import { ThemeProvider } from '@material-ui/core/styles';
import productTheme from './product/theme';
import marketingTheme from './marketing/theme';

var ProductThemeProvider = function ProductThemeProvider(_ref) {
  var children = _ref.children,
      variant = _ref.variant;
  return React.createElement(ThemeProvider, {
    theme: productTheme({
      variant: variant
    })
  }, children);
};

var MarketingThemeProvider = function MarketingThemeProvider(_ref2) {
  var children = _ref2.children;
  return React.createElement(ThemeProvider, {
    theme: marketingTheme
  }, children);
};

export { ProductThemeProvider, productTheme, MarketingThemeProvider, marketingTheme };